module.exports = __webpack_public_path__ + "static/media/IMG_0248.e2e97011.jpg";